const _excluded = ["componentName", "fallback", "remote"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "./ErrorBoundary";
const withErrorBoundary = _ref => {
  let {
      componentName,
      fallback,
      remote
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Component =>
  // eslint-disable-next-line react/display-name
  props => /*#__PURE__*/React.createElement(ErrorBoundary, _extends({
    componentName,
    fallback,
    remote
  }, rest), /*#__PURE__*/React.createElement(Component, props));
};
withErrorBoundary.defaultProps = {
  fallback: null,
  remote: null
};
withErrorBoundary.propTypes = {
  componentName: PropTypes.string.isRequired,
  fallback: PropTypes.node,
  remote: PropTypes.string
};
export default withErrorBoundary;